var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-row"},[_c('div',{staticClass:"header-inner-wrap"},[_c('div',{staticClass:"logo-wrap"},[_c('CompanyLogo')],1),_c('div',{staticClass:"title-wrap"},[_vm._v(" "+_vm._s(_vm.appTitle)+" ")]),_c('div',{staticClass:"time-wrap"},[_c('HeaderTime')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }